import styled from 'styled-components'
import { ButtonMenu, ButtonMenuItem } from '@echodex/uikit'
import { useState } from 'react'
import { maxMediaQueries } from 'utils/theme'
import V2Table from './v2Table'
import V3Table from './v3Table'

const StyledAllPools = styled.div`
    overflow: hidden;
    ${maxMediaQueries.md} {
        overflow-x: auto;
        table {
            width: 150%;
        }
    }
    ${maxMediaQueries.sm} {
        table {
            width: 300%;
        }
    }
`

export const StyledAllPool = styled.div`
    box-shadow: ${({ theme }) => theme.shadows.app};
    border: 1px solid ${({ theme }) => theme.colors.borderCard};
`

enum FILTER {
    V3 = 0,
    V2 = 1,
}

const AllPools = () => {
    const [selectedTypeIndex, setSelectedTypeIndex] = useState(FILTER.V3)

    return (
        <StyledAllPool className="rounded-[12px] bg-gray mt-6 md:mt-8 overflow-hidden">
            <div className="py-6 px-4 max-md:px-4 max-md:py-3 max-md:pb-4 border-solid border-[#515255] facb cursor-pointer max-md:flex-col max-md:items-start">
                <div className="gap-4 font-semibold text-pri fa-center max-md:text-sm max-md:facb max-md:w-full max-md:mb-4">
                    <div className="gap-4 fa-center">
                        <span className="text-[18px]">All Pools</span>
                    </div>
                </div>
                <ButtonMenu
                    scale="sm"
                    activeIndex={selectedTypeIndex}
                    onItemClick={(index) => setSelectedTypeIndex(index)}
                    variant="subtle"
                >
                    <ButtonMenuItem>V3</ButtonMenuItem>
                    <ButtonMenuItem>V2</ButtonMenuItem>
                </ButtonMenu>
                {/* <div className="gap-2 fa-center md:gap-4 max-md:facb max-md:w-full">
                    <AvailableSearch
                        placeholder="Search in all pools..."
                        valueInput={valueInput}
                        setValueInput={setValueInput}
                        className="max-md:flex-1"
                    />
                    <ButtonIcon
                        icon="akar-icons:chevron-down"
                        onClick={toggle}
                        className={classnames(showTable && 'rotate-180')}
                    />
                </div> */}
            </div>
            <StyledAllPools>
                {selectedTypeIndex === FILTER.V2 && <V2Table />}
                {selectedTypeIndex === FILTER.V3 && <V3Table />}
            </StyledAllPools>
        </StyledAllPool>
    )
}

export default AllPools
